var LanguageEnum = {
    fr: { name:'Français', flagCode: 'fr', i18nCode: 'fr' },
    en: { name: 'English', flagCode: 'gb', i18nCode: 'en'},
    es: { name: 'Spanish', flagCode: 'es', i18nCode: 'es'},
    nl: { name: 'Nederlands', flagCode: 'nl', i18nCode: 'nl'}
};

module.exports = LanguageEnum;



// WEBPACK FOOTER //
// ./src/enums/LanguageEnum.js